export const userLanguagePreference = () => {
    return (
        navigator.languages && navigator.languages.length
            ? navigator.languages[0]
            : navigator.language
    ).toLowerCase();
};

export const pageLanguageSetting = () => {
    return document.querySelector("html").getAttribute("lang").toLowerCase();
};
